module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pageTitle":"Zugangsrechte verwalten","deleteUserPendingMessage":"Benutzerzugang wird entfernt...","noUsers":"Keine Benutzer-/innen","addToUser":"Benutzer/-in hinzufügen","deleteButtonLabel":"Zugriff entziehen","deleteConfirmation":"Wollen Sie \\"{name}\\" wirklich den Zugriff entziehen?","returnButton":"Zurück"}}')
  delete Component.options._Ctor
}
